<template>
  <RouterLink
    :to="to"
    v-tooltip="`${first} ${last}`"
    class="flex items-center gap-1.5"
  >
    <span
      class="flex h-[28px] w-[28px] items-center justify-center rounded-full bg-primary-100 text-white-100"
      >{{ $getFirstLetter(first) }}</span
    >
    <span
      class="mt-[1px] block flex-1"
      :class="[isTruncate ? 'max-w-[120px] truncate' : '']"
    >
      {{ first }} {{ last }}
    </span>
  </RouterLink>
</template>

<script>
export default {
  name: "FallbackName",
  props: {
    to: Object,
    first: String,
    last: String,
    isTruncate: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
